import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/machineD3.png'
import _imports_1 from '@/assets/zhenduan.png'
import _imports_2 from '@/assets/weixiu.png'
import _imports_3 from '@/assets/menxian.png'


const _hoisted_1 = { class: "mt-4 w-full relative" }
const _hoisted_2 = { class: "w-full flex items-center mt-4 ml-4 mb-4" }
const _hoisted_3 = { class: "size18 ml-2" }
const _hoisted_4 = { class: "mt-2 w-full flex" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 w-full px-2"
}
const _hoisted_6 = { class: "w-full flex items-center justify-center mb-4" }
const _hoisted_7 = { class: "mt-2 w-full cursor-pointer" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "w-full flex items-center" }
const _hoisted_10 = {
  key: 0,
  style: {"width":"18px","height":"18px"},
  src: _imports_1,
  alt: ""
}
const _hoisted_11 = {
  key: 1,
  style: {"width":"18px","height":"18px"},
  src: _imports_2,
  alt: ""
}
const _hoisted_12 = {
  key: 2,
  style: {"width":"18px","height":"18px"},
  src: _imports_3,
  alt: ""
}
const _hoisted_13 = {
  key: 4,
  class: "ml-2"
}
const _hoisted_14 = {
  key: 5,
  class: "ml-2"
}
const _hoisted_15 = {
  key: 6,
  class: "box6 opt8"
}
const _hoisted_16 = {
  key: 7,
  class: "box6 opt8"
}
const _hoisted_17 = { class: "mt-2" }
const _hoisted_18 = {
  class: "mt-2 opt6",
  style: {"font-size":"12px"}
}
const _hoisted_19 = {
  key: 1,
  style: {"position":"absolute","left":"-820px","width":"800px","top":"-20px"}
}
const _hoisted_20 = { style: {"color":"#fff"} }
const _hoisted_21 = { class: "w-full flex" }
const _hoisted_22 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_23 = { class: "w-full flex items-center" }
const _hoisted_24 = { style: {"font-size":"20px"} }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_26 = { class: "ml-2" }
const _hoisted_27 = {
  class: "mt-4",
  style: {"font-size":"20px"}
}
const _hoisted_28 = { style: {"color":"white"} }
const _hoisted_29 = { style: {"color":"white"} }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  class: "opt6",
  style: {"margin-top":"8px","color":"#fff"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "w-full flex justify-center" }
const _hoisted_34 = { style: {"color":"#fff"} }
const _hoisted_35 = { class: "w-full flex" }
const _hoisted_36 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_37 = { class: "w-full flex items-center" }
const _hoisted_38 = { style: {"font-size":"20px"} }
const _hoisted_39 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_40 = { class: "ml-2" }
const _hoisted_41 = { class: "w-full flex justify-center" }

import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import MaintenanceReportDetailComponent from "../report4/common/maintenanceReportDetails.vue";
import DiagnosticReportDetails2Component from "../report4/common/DiagnosticReportDetails2.vue";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons-vue";
import { langList } from "@/common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getGroupName, transformDate, transformLocalDate, transformBeiJingDate } from "@/common/tools";
import { message } from "ant-design-vue";
import { getLanguage,getTranslation } from "@/common/translate";


export default /*@__PURE__*/_defineComponent({
  __name: 'workflow-widget',
  props: {
  machineInfo: null,
},
  setup(__props) {

const router = useRouter();

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
  langObj.value = langList[language.value]
}
getLang()

const props: any = __props;
let machineInfo: any = ref({});

let machine_id = ref();
watch(
    () => props.machineInfo,
    (newValue, oldValue) => {
      machine_id.value = props.machineInfo.id;
      machineInfo.value = props.machineInfo;
      init();
    }
);

onMounted(() => {
  machine_id.value = props.machineInfo?.id;
  machineInfo.value = props.machineInfo;
  init();
});

let conditionList = [
  { label: "健康", value: [0], color: "#61c08f", color2: "#3a3a3aff" },
  { label: "可用", value: [1, 2], color: "#706a00ff", color2: "#706a00ff" },
  { label: "警戒", value: [3, 4, 5], color: "#cd5f3b", color2: "#cd5f3b" },
  { label: "故障", value: [6, 7], color: "#921e37", color2: "#921e37" },
];

const init = () => {
  if (!machine_id.value) return;
  getMachineWarning();
};

// 获取设备事件
let warningType = ref(1);
let warningTotal = ref(0);
let machineWarningData: any = ref([]);
const getMachineWarning = async () => {
  let config: any = {
    params: {
      skip: 1,
      take: 3,
      machineId: machine_id.value,
      typeList: warningType.value === 1 ? [1, 4] : [2],
    },

    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/workflows", config);
  if (result && result.data) {
    machineWarningData.value = result.data.list;
    warningTotal.value = result.data.total;
  }
};

// 查看更多
const viewMore = () => {
  router.push("/warning-manage/warning-list");
};

// 查看报告
let orderId = ref();
let reportId = ref();
let reportType = ref();
let maint = ref();
let Diagn = ref();
const viewReport = (workflow: any) => {
  orderId.value = workflow.id;
  reportType.value = workflow.type;
  if (workflow.reportIds.length) {
    reportId.value = workflow.reportIds[0];
  } else {
    reportId.value = null;
  }

  setTimeout(() => {
    if ((workflow.type === 2 || workflow.type === 3) && reportId.value) {
      maint.value.show(reportId.value);
    }
  }, 500);

  setTimeout(() => {
    if (workflow.type === 1 && reportId.value) {
      Diagn.value.show(reportId.value);
    }
  }, 500);
};
const cancelReport = () => {
  reportId.value = null;
  reportType.value = null;
};

let form: any = ref({
  value: "",
  begin: null,
  end: null,
  type: 2,
  machineName: "",
  machineId: "",
  groupId: "",
  groupName: "",
  factoryId: "",
  condition: null,
  faultCause: "",
});
let nohandleList: any = ref([]);
let visibleAdd = ref(false);
let conditionAdd = [
  { label: "健康", value: 0 },
  { label: "可用", value: 1 },
  { label: "警戒", value: 3 },
  { label: "故障", value: 6 },
];
let columns = [
  {
    title: langObj.value["报警时间"],
    dataIndex: "date",
  },
  {
    title: langObj.value["严重程度"],
    dataIndex: "condition",
  },
  {
    title: langObj.value["故障描述"],
    dataIndex: "diagnosticNotes",
  },
];
const addRepair = () => {
  machineInfo.value.groupName = getGroupName(machineInfo.value.groupId);
  form.value.groupName = machineInfo.value.groupName;
  form.value.machineName = machineInfo.value.machineName;
  form.value.machineId = machineInfo.value.machineId;
  form.value.groupId = machineInfo.value.groupId;
  form.value.factoryId = machineInfo.value.factoryId;
  form.value.maintainPerson = JSON.parse(
      localStorage.getItem("memberInfo") || ""
  )?.nickName;
  nohandleList.value = [];
  visibleAdd.value = true;
  getNotHandleOrder();
};

//获取未处理的诊断工单
const getNotHandleOrder = async () => {
  let config: any = {
    params: {
      machineId: machine_id.value,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/workflows/nohandle", config);
  if (result && result.data) {
    nohandleList.value = result.data;
  }
};

let selectedRowKeys = ref<any[]>([]);
const onSelectChange = (ev: any) => {
  selectedRowKeys.value = ev;
};

const submitAdd = async () => {
  let submit = JSON.parse(JSON.stringify(form.value));
  if (!submit.begin) {
    message.warning(langObj.value["请选择开始时间"]);
    return;
  } else {
    submit.begin = transformDate(submit.begin);
  }

  if (!submit.end) {
    message.warning(langObj.value["请选择结束时间"]);
    return;
  } else {
    submit.end = transformDate(submit.end);
  }

  if (!submit.maintainPerson) {
    message.warning(langObj.value["请填写检修人员"]);
    return;
  }

  if (!submit.condition && submit.condition !== 0) {
    message.warning(langObj.value["请选择现场设备状态"]);
    return;
  }

  if (!submit.faultCause) {
    message.warning(langObj.value["请填写故障原因"]);
    return;
  }

  if (!submit.maintainMessage) {
    message.warning(langObj.value["请填写检修内容"]);
    return;
  }

  let list = nohandleList.value.filter((p: any) =>
      selectedRowKeys.value.includes(p._id)
  );

  submit.list = list.map((d: any) => ({
    date: d.date,
    condition: d.condition,
    diagnosticNotes: d.diagnosticNotes,
    id: d._id,
  }));

  if (fileList.value && fileList.value.length) {
    submit.pictures = fileList.value.map((p: any) => ({
      url: p.url,
    }));
  } else {
    submit.pictures = [];
  }

  submit.begin = transformBeiJingDate(submit.begin)
  submit.end = transformBeiJingDate(submit.end)

  let data: any = {
    repairReport: submit,
    date: submit.end,
    machineIds: [machine_id.value],
    factoryId: submit.factoryId,
    pictures: submit.pictures,
    type: 2,
    workflow: true,
  };

  let result = await request.post("/api/reports", data);

  if (result && result.status) {
    message.success(langObj.value["新增成功"]);
    visibleAdd.value = false;
    await getMachineWarning();
  } else {
    message.warning(langObj.value["操作失败"] + "!");
  }
};

//批量关闭报警
let formClose = ref({
  closeCause: "",
});

let visibledel = ref(false);
const deleteWaring = () => {
  formClose.value.closeCause = "";
  nohandleList.value = [];
  visibledel.value = true;
  getNotHandleOrder();
};

// 关闭报警
let selectedRowKeysDel: any = ref([]);

const onSelectChangeDel = (ev: any) => {
  selectedRowKeysDel.value = ev;
};

const submitClose = async () => {
  if (!formClose.value.closeCause) {
    message.warning(langObj.value["请填写关闭原因"]);
    return;
  }
  if (!selectedRowKeysDel.value || !selectedRowKeysDel.value.length) {
    message.warning(langObj.value["请选择关闭的故障项"]);
    return;
  }

  let form = {
    closeCause: formClose.value.closeCause,
    list: [],
  };

  let list = nohandleList.value.filter((p: any) =>
      selectedRowKeysDel.value.includes(p._id)
  );
  if (list && list.length) {
    form.list = list.map((d: any) => ({
      date: d.date,
      condition: d.condition,
      diagnosticNotes: d.diagnosticNotes,
      id: d._id,
    }));
  }
  let result = await request.post("/api/workflows/close", form);
  if (result && result.status == 200) {
    message.success(langObj.value["关闭成功"] + "!");
    visibledel.value = false;
  } else {
    message.warning(langObj.value["操作失败"]);
  }
};

//**图片上传* */
let fileList = ref<any>([]);
const previewVisible = ref(false);
const previewImage = ref("");
const previewTitle = ref("");
const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = "";
};

const handlePreview = async (file: any) => {
  previewImage.value = file.url;
  previewVisible.value = true;
  previewTitle.value = file.url;
};

let uploadFile = async (options: any) => {
  const { onSuccess, onError, file } = options;
  let formData = new FormData();
  formData.append("file", file); // file为要上传的文件
  const config = {
    headers: {
      requestId: uuidv4(),
      "Content-Type": "multipart/form-data",
    },
  };
  let res = await request.post("/api/upload", formData, config);
  if (res) {
    file.url = res.data;
    onSuccess({ url: file.url, status: "done" });
  }
};

let getDiagLang = (record) => {
  try {
    if (record.diagnosticNotes.includes('测点：')) {
      let arr = record.diagnosticNotes.split("；");
      if (arr.length > 1) {
        let s1 = arr[0].split("：");
        let s1_1 = getLanguage(s1[0]);
        let s1_2 = getTranslation(s1[1]);

        let s2 = arr[1].split("：");
        
        let s2str = getLanguage(s2[0])+'：'+s2[1].replace('超过1级阈值',getLanguage('超过1级阈值')).replace('超过2级阈值',getLanguage('超过2级阈值')).replace('超过3级阈值',getLanguage('超过3级阈值'))

        return s1_1 + "：" + s1_2 + "；"+s2str;
      } else {
        return record.diagnosticNotes
      }
    } else {
      let arr = record.diagnosticNotes.split("；").filter((p:any) => p)
      let strArr:any = []
      arr.map((d:any) => {
        let s1 = getTranslation(d.split("：")[0]);
        let s2 = d.split("：")[1]
        let s2L = s2.split("，").filter((p:any) => p)
        let s3L:any = []
        s2L.map((d:any) => {
          s3L.push(getLanguage(d)) 
        })
        let s3 = s3L.join("，")
        let s4 = s1 + "：" + s3;
        strArr.push(s4)
      })
      return strArr.join("；")
    }
  } catch (error) {
    console.log('error', error)
    return record.diagnosticNotes
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(language) === 'English' ? _unref(enUS) : _unref(zhCN)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[14] || (_cache[14] = _createElementVNode("img", {
            style: {"width":"18px","height":"18px"},
            src: _imports_0,
            alt: ""
          }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(langObj)['设备事件']) + "（" + _toDisplayString(_unref(warningTotal)) + _toDisplayString(_unref(getLanguage)('条')) + "）", 1),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
          _createElementVNode("div", {
            onClick: viewMore,
            class: "opt8",
            style: {"font-size":"12px","cursor":"pointer"}
          }, _toDisplayString(_unref(langObj)['查看更多']) + " > ", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ()=>{(_isRef(warningType) //@ts-ignore
 ? warningType.value = 1 : warningType = 1); getMachineWarning()}),
            style: _normalizeStyle({ background: _unref(warningType) === 1 ? '#171325ff' : '' }),
            class: "btn1 cursor-pointer"
          }, _toDisplayString(_unref(langObj)['报警事件']), 5),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ()=>{(_isRef(warningType) //@ts-ignore
 ? warningType.value = 2 : warningType = 2); getMachineWarning()}),
            style: _normalizeStyle([{ background: _unref(warningType) === 2 ? '#171325ff' : '' }, {"margin-left":"10px"}]),
            class: "btn1 cursor-pointer"
          }, _toDisplayString(_unref(langObj)['检修记录']), 5),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex-1" }, null, -1))
        ]),
        (_unref(warningType) === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "btn2-o flex items-center cursor-pointer",
                  onClick: addRepair,
                  style: {"padding":"4px 8px","max-width":"145px"}
                }, [
                  _createVNode(_unref(PlusOutlined), { class: "mr-1" }),
                  _createTextVNode(" " + _toDisplayString(_unref(langObj)['添加检修记录']), 1)
                ]),
                _createElementVNode("div", {
                  class: "btn2-o ml-2 flex items-center cursor-pointer",
                  onClick: deleteWaring,
                  style: {"padding":"4px 18px","width":"145px"}
                }, [
                  _createVNode(_unref(CloseOutlined), { class: "mr-1" }),
                  _createTextVNode(" " + _toDisplayString(_unref(langObj)['批量关闭报警']), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineWarningData), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (viewReport(item)),
              class: "box5 mt-2"
            }, [
              _createElementVNode("div", _hoisted_9, [
                (item.type === 1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true),
                (item.type === 2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : _createCommentVNode("", true),
                (item.type === 4)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                  : _createCommentVNode("", true),
                (item.type === 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      style: _normalizeStyle([{ color: _unref(conditionList).find((p) =>   p.value.includes(item.condition)  )?.color }, {"font-size":"16px"}]),
                      class: "ml-2"
                    }, _toDisplayString(_unref(langObj)['诊断报警']) + "：" + _toDisplayString(_unref(langObj)[_unref(conditionList).find((p) => p.value.includes(item.condition))?.label || ""]), 5))
                  : _createCommentVNode("", true),
                (item.type === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(langObj)['现场维修']), 1))
                  : _createCommentVNode("", true),
                (item.type === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(langObj)['门限报警']), 1))
                  : _createCommentVNode("", true),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                (  item.reportIds && item.reportIds.length && item.type === 1 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(langObj)['诊断报告']), 1))
                  : _createCommentVNode("", true),
                (
                      item.reportIds && item.reportIds.length && item.type === 2
                    )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(langObj)['检修报告']), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(getDiagLang)(item) ||item.diagnosticNotes), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(transformLocalDate)(item.date)), 1)
            ], 8, _hoisted_8))
          }), 128))
        ]),
        (_unref(reportId))
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_unref(reportType) === 2 || _unref(reportType) === 3)
                ? (_openBlock(), _createBlock(MaintenanceReportDetailComponent, {
                    key: 0,
                    ref_key: "maint",
                    ref: maint,
                    onCancel: cancelReport
                  }, null, 512))
                : _createCommentVNode("", true),
              (_unref(reportType) === 1)
                ? (_openBlock(), _createBlock(DiagnosticReportDetails2Component, {
                    key: 1,
                    ref_key: "Diagn",
                    ref: Diagn,
                    onCancel: cancelReport
                  }, null, 512))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_modal, {
        visible: _unref(visibleAdd),
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_isRef(visibleAdd) ? (visibleAdd).value = $event : visibleAdd = $event)),
        closable: false,
        footer: null,
        bodyStyle: { background: '#080718ff' },
        style: {"top":"15%"},
        width: "1200px",
        maskClosable: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(visibleAdd) //@ts-ignore
 ? visibleAdd.value = false : visibleAdd = false))
              }, [
                _createVNode(_unref(CloseOutlined), { style: {"font-size":"20px"} })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(langObj)['添加检修记录']), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(langObj)['故障信息(请勾选此次维修的故障项)']), 1)
            ]),
            _createVNode(_component_a_table, {
              "row-selection": {
            selectedRowKeys: _unref(selectedRowKeys),
            onChange: onSelectChange,
          },
              columns: _unref(columns),
              "data-source": _unref(nohandleList),
              pagination: false,
              rowKey: "_id",
              style: {"background-color":"#080718ff"}
            }, {
              bodyCell: _withCtx(({ column, text, record }) => [
                (column.dataIndex === 'condition')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(langObj)[_unref(conditionList).find((p) => p.value === text)?.label || ""]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'date')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(transformBeiJingDate)(text)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'diagnosticNotes')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(getDiagLang)(record)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "data-source"]),
            _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(langObj)['维修详情']), 1),
            _createVNode(_component_a_form, {
              ref: "formRef",
              name: "advanced_search",
              class: "ant-advanced-search-form",
              model: _unref(form),
              "label-col": { style: { width: '180px' } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "begin",
                          label: _unref(langObj)['开始时间'],
                          rules: [{ required: true, message: _unref(langObj)['请选择开始时间'] }],
                          allowClear: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_date_picker, {
                              value: _unref(form).begin,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).begin) = $event)),
                              "show-time": "",
                              placeholder: _unref(langObj)['请选择时间']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "end",
                          label: _unref(langObj)['结束时间'],
                          rules: [{ required: true, message: _unref(langObj)['请选择结束时间'] }],
                          allowClear: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_date_picker, {
                              value: _unref(form).end,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).end) = $event)),
                              "show-time": "",
                              placeholder: _unref(langObj)['请选择时间']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "value",
                          label: _unref(langObj)['设备名称'],
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getTranslation)(_unref(form).machineName)), 1)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "value",
                          label: _unref(langObj)['设备区域'],
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(getTranslation)(_unref(form).groupName)), 1)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "maintainPerson",
                          label: _unref(langObj)['检修人员'],
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(form).maintainPerson,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).maintainPerson) = $event)),
                              style: {"width":"210px"}
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "condition",
                          label: _unref(langObj)['现场设备状态'],
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _unref(form).condition,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).condition) = $event)),
                              style: {"width":"210px"},
                              placeholder: _unref(langObj)['请选择现场设备状态'],
                              allowClear: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionAdd), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: item.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(langObj)[item.label]), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "faultCause",
                          label: _unref(langObj)['故障原因'],
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: _unref(form).faultCause,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).faultCause) = $event)),
                              placeholder: _unref(langObj)['请输入故障原因'],
                              rows: 4
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "maintainMessage",
                          label: _unref(langObj)['检修内容'],
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: _unref(form).maintainMessage,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).maintainMessage) = $event)),
                              placeholder: _unref(langObj)['请输入检修内容'],
                              rows: 4
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          style: {"margin-left":"10px"},
                          name: "value",
                          label: _unref(langObj)['检修图片']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_upload, {
                              "file-list": _unref(fileList),
                              "onUpdate:fileList": _cache[9] || (_cache[9] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : fileList = $event)),
                              "list-type": "picture-card",
                              onPreview: handlePreview,
                              "custom-request": _unref(uploadFile),
                              "auto-upload": false,
                              accept: "image",
                              "max-count": 9
                            }, {
                              default: _withCtx(() => [
                                (!_unref(fileList) || _unref(fileList).length < 9)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createVNode(_unref(PlusOutlined), {
                                        class: "opt6",
                                        style: {"color":"#fff"}
                                      }),
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(langObj)['上传']), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["file-list", "custom-request"]),
                            _createVNode(_component_a_modal, {
                              visible: previewVisible.value,
                              title: previewTitle.value,
                              footer: null,
                              onCancel: handleCancel
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  alt: "example",
                                  style: {"width":"100%"},
                                  src: previewImage.value
                                }, null, 8, _hoisted_32)
                              ]),
                              _: 1
                            }, 8, ["visible", "title"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                onClick: submitAdd,
                style: {"background-color":"#171325ff","padding":"5px 10px","width":"100px","font-size":"20px","text-align":"center","cursor":"pointer"}
              }, _toDisplayString(_unref(langObj)['提交']), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: _unref(visibledel),
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (_isRef(visibledel) ? (visibledel).value = $event : visibledel = $event)),
        closable: false,
        footer: null,
        bodyStyle: { background: '#080718ff' },
        style: {"top":"30%"},
        width: "1200px",
        maskClosable: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_isRef(visibledel) //@ts-ignore
 ? visibledel.value = false : visibledel = false))
              }, [
                _createVNode(_unref(CloseOutlined), { style: {"font-size":"20px"} })
              ])
            ]),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(langObj)['关闭报警']), 1),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(langObj)['故障信息（请勾选此次关闭的故障项）']), 1)
            ]),
            _createVNode(_component_a_table, {
              "row-selection": {
            selectedRowKeys: _unref(selectedRowKeysDel),
            onChange: onSelectChangeDel,
          },
              columns: _unref(columns),
              "data-source": _unref(nohandleList),
              pagination: false,
              rowKey: "_id",
              style: {"background-color":"#080718ff"}
            }, {
              bodyCell: _withCtx(({ column, text, record }) => [
                (column.dataIndex === 'condition')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", {
                        style: _normalizeStyle([{"width":"12px","height":"12px","border-radius":"50%"}, {
                    background: _unref(conditionList).find((p) => p.value === text)
                      ?.color,
                  }])
                      }, null, 4),
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(langObj)[_unref(conditionList).find((p) => p.value === text)?.label || ""]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'date')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(transformBeiJingDate)(text)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'diagnosticNotes')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(getDiagLang)(record)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "data-source"]),
            _createVNode(_component_a_form, {
              ref: "formRef",
              name: "advanced_search",
              class: "ant-advanced-search-form",
              style: {"margin-top":"20px"},
              model: _unref(formClose)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: "closeCause",
                          label: _unref(langObj)['关闭原因'],
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: _unref(formClose).closeCause,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formClose).closeCause) = $event)),
                              placeholder: _unref(langObj)['请输入关闭原因'],
                              rows: 4
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", {
                onClick: submitClose,
                style: {"background-color":"#171325ff","padding":"5px 10px","width":"100px","font-size":"20px","text-align":"center","cursor":"pointer"}
              }, _toDisplayString(_unref(langObj)['提交']), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})